import type { NotificationCategory } from '@nexops/shared';
import { cn } from '@/shared/lib/cn';
import { CATEGORY_STYLE } from '../lib/category-style';

/** Gradient icon tile per notification category (ZUR OPS look). */
export function CategoryTile({ category, size = 'md', dim, className }: { category: NotificationCategory; size?: 'sm' | 'md'; dim?: boolean; className?: string }) {
  const s = CATEGORY_STYLE[category];
  return (
    <span
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center rounded-xl bg-gradient-to-br text-white shadow-sm',
        s.gradient,
        size === 'md' ? 'size-10 [&_svg]:size-5' : 'size-8 rounded-lg [&_svg]:size-4',
        dim && 'opacity-60 saturate-50',
        className,
      )}
    >
      <s.icon />
    </span>
  );
}
